module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 15
// module chunks = 0